import { render, staticRenderFns } from "./FooterCurrency.vue?vue&type=template&id=55fef208&lang=pug&"
import script from "./FooterCurrency.vue?vue&type=script&lang=js&"
export * from "./FooterCurrency.vue?vue&type=script&lang=js&"
import style0 from "./FooterCurrency.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55fef208')) {
      api.createRecord('55fef208', component.options)
    } else {
      api.reload('55fef208', component.options)
    }
    module.hot.accept("./FooterCurrency.vue?vue&type=template&id=55fef208&lang=pug&", function () {
      api.rerender('55fef208', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FooterCurrency.vue"
export default component.exports